import React from 'react';
import { Mail, Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark border-t border-dark-border py-12 px-4" data-id="element-108">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-109">
        <div className="flex items-center gap-3 mb-6" data-id="element-110">
          <span className="text-3xl" data-id="element-111">🏛️</span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-white tracking-wider" data-id="element-112">
            GRECIA LEGENDARIA
          </h2>
        </div>

        <p className="text-gray-400 max-w-2xl mb-12" data-id="element-113">
          La colección definitiva para explorar el fascinante mundo de la
          Antigua Grecia.
        </p>

        <div className="flex flex-col md:flex-row gap-6 md:gap-12 mb-12 text-gray-400" data-id="element-114">
          <a href="mailto:ebooksolutions.on@gmail.com" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-115">
            <Mail className="w-5 h-5" data-id="element-116" />
            <span data-id="element-117">ebooksolutions.on@gmail.com</span>
          </a>
          <a href="https://instagram.com/digital_solutions.on" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-118">
            <Instagram className="w-5 h-5" data-id="element-119" />
            <span data-id="element-120">@digital_solutions.on</span>
          </a>
          <a href="https://facebook.com/digitalsolutions" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-121">
            <Facebook className="w-5 h-5" data-id="element-122" />
            <span data-id="element-123">Digital Solutions</span>
          </a>
        </div>

        <div className="w-full border-t border-dark-border/50 pt-8 flex flex-col items-center gap-4" data-id="element-124">
          <p className="text-sm text-gray-600" data-id="element-125">
            © Grecia Legendaria 2026 Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}